import { Injectable, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({providedIn: 'root'})

export class MenuWorkflowService {

    private isOpen$: BehaviorSubject<boolean> = new BehaviorSubject(false)    
    
    constructor(){}

    getOpenstatus(){
        return this.isOpen$.asObservable()
    }

    openMenu(){
        this.isOpen$.next(true)
    }

    closeMenu(){
        this.isOpen$.next(false)
    }
}